import React from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import AppRouter from "./routers/AppRouter";

class App extends React.Component<any, any> {
  componentDidUpdate() {
    const script = document.createElement("script");

    const scriptText = document.createTextNode(
      `(function() { var qs,js,q,s,d=document, gi=d.getElementById, ce=d.createElement, gt=d.getElementsByTagName, id="typef_orm", b="https://embed.typeform.com/"; if(!gi.call(d,id)) { js=ce.call(d,"script"); js.id=id; js.src=b+"embed.js"; q=gt.call(d,"script")[0]; q.parentNode.insertBefore(js,q) } })() `
    );

    script.appendChild(scriptText);
    document.head.appendChild(script);
  }

  render() {
    return (
      <CssBaseline>
        <AppRouter />
      </CssBaseline>
    );
  }
}

export default App;
